import React from "react";
import { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { LargeModal } from "common/modal/LargeModalStyling";

interface FreeTrialModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
  white-space: normal;
`;

const FreeTrialModal = ({
  visible,
  onConfirm,
  onCancel,
}: FreeTrialModalProps) => {
  const { t } = useTranslation("new_sign_up");

  return (
    <LargeModal
      title={t("FREE TRIAL")}
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
    >
      <ModalText
        dangerouslySetInnerHTML={{
          __html: t(
            `To receive the free trial credits, go through the next steps in one go`
          ),
        }}
      />

      <ModalButton onClick={() => onConfirm()}>{t("PROCEED")}</ModalButton>
    </LargeModal>
  );
};

export default FreeTrialModal;
